import 'raf/polyfill'
import 'babel-polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import { BrowserRouter, Route, Redirect,Switch,HashRouter } from 'react-router-dom'
import Reducers from './reducer'
import Index from './container/index/index'
import  './static/css/resert.css'
import './static/css/header.css'
import AuthRoute from './component/auth-route/AuthRoute.js'
import './config.js'
import MyWelfare from './container/center-welfare/welfare.js'
import W404 from './container/404/404.js'
import MyMember from './container/my-member/my-member.js'
import MyMessage from './container/my-message/message.js'
import NewsDetail from './container/news-detail/news.js'
import NewsList from './container/news-list/news-list.js'
import ReturnM from './container/return/return-m.js'
import ReturnPC from './container/return-pc/return.js'
import ReturnDetail from './container/return-detail/detail.js'
import ReturnDetailPC from './container/return-detail-pc/detail.js'
import NewGame from './container/new-game-list/new-game-list.js'
import Xinxiang from './container/xinxiang-detail/detail.js'
import LoginPage from './container/login-page/index.js'
const store = createStore(Reducers, compose(
	applyMiddleware(thunk),
	window.devToolsExtension?window.devToolsExtension():f=>f
))
//<Route path="/return-pc" component= {ReturnPC}></Route>
//<Route path='/return-detail-pc/:id' component={ReturnDetailPC}></Route>
var pr1=(<Provider store={store}>
		<BrowserRouter>
			<div>
				<AuthRoute></AuthRoute>
				<Switch>
					
					<Route path='/index'  component= {Index} ></Route>
					<Route path='/'  component= {Index} exact></Route>
					<Route path='/my-welfare' component= {MyWelfare} ></Route>
					<Route path='/my-member' component= {MyMember} ></Route>
					<Route path='/my-message' component= {MyMessage} ></Route>
					<Route path='/news-detail/:id' component= {NewsDetail} ></Route>
					<Route path='/news-list' component= {NewsList} ></Route>
					
					<Route path='/return-m' component= {ReturnM} ></Route>

						
					<Route path='/return-detail/:id' component= {ReturnDetail} ></Route>					
					<Route path='/new-game' component= {NewGame} ></Route>
					<Route path='/game-detail/:id' component= {Xinxiang} ></Route>
					<Route path='/login' component= {LoginPage} ></Route>
					<Route path='/404' component= {W404} ></Route>
					<Redirect to='/404'></Redirect>
				</Switch>
			</div>
		</BrowserRouter>
	</Provider>)
var pr2 = (<Provider store={store}>
		<HashRouter>
			<div>
				<AuthRoute></AuthRoute>
				<Switch>
					
					<Route path='/index' component= {Index}></Route>
					<Route  exact path='/'  component= {Index}></Route>
					<Route path='/my-welfare' component= {MyWelfare} ></Route>
					<Route path='/my-member' component= {MyMember} ></Route>
					<Route path='/my-message' component= {MyMessage} ></Route>
					<Route path='/news-detail/:id' component= {NewsDetail} ></Route>
					<Route path='/news-list' component= {NewsList} ></Route>
					<Route path='/new-game' component= {NewGame} ></Route>
					<Route path='/login' component= {LoginPage} ></Route>
					<Route path='/game-detail/:id' component= {Xinxiang} ></Route>
					<Route path='/404' component= {W404} ></Route>
					
					<Redirect to='/404'></Redirect>
				</Switch>
			</div>
		</HashRouter>
	</Provider>
	)
var pr3 = (<div>不支持该浏览器</div>)
	



function getBrowserInfo() {
	var agent = navigator.userAgent.toLowerCase();
	var regStr_ie = /msie [\d.]+;/gi;
	var regStr_ff = /firefox\/[\d.]+/gi
	var regStr_chrome = /chrome\/[\d.]+/gi;
	var regStr_saf = /safari\/[\d.]+/gi;
	var isIE = agent.indexOf("compatible") > -1 && agent.indexOf("msie" > -1); //判断是否IE<11浏览器  
	var isEdge = agent.indexOf("edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
	var isIE11 = agent.indexOf('trident') > -1 && agent.indexOf("rv:11.0") > -1;
	if (isIE) {
		var reIE = new RegExp("msie (\\d+\\.\\d+);");
		reIE.test(agent);
		var fIEVersion = parseFloat(RegExp["$1"]);
		if (fIEVersion == 7) {
			return pr3;
		} else if (fIEVersion == 8) {
			return pr3;
		} else if (fIEVersion == 9) {
			return pr2;
		} else if (fIEVersion == 10) {
			return pr1;
		} 
	} //isIE end 
	if (isIE11) {
		return pr1;
	}
	//firefox
	if (agent.indexOf("firefox") > 0) {
		return pr1;
	}
	//Safari
	if (agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0) {
		return pr1;
	}
	//Chrome
	if (agent.indexOf("chrome") > 0) {
		return pr1;
	}
	return pr1;
}


ReactDOM.render(
	
	getBrowserInfo(),

	document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.js